<template>
  <!-- App -->
  <f7-app :params="f7params">

    <!-- Statusbar -->
    <f7-statusbar></f7-statusbar>

    <!-- Left Panel -->
    <f7-panel id="leftPanelwrapper" left cover theme-dark>
      <leftPanel></leftPanel>
    </f7-panel>

    <!-- Right Panel -->
    <f7-panel right cover theme-dark>
     
    </f7-panel>

    <!-- Main View -->
    <f7-view id="main-view" url="/" main></f7-view>


  </f7-app>
</template>

<script>
// Import Routes
import routes from './routes.js'
import leftPanel from './partial/panel-left.vue';
import rightPanel from './partial/panel-right.vue';

export default {
  components:{leftPanel, rightPanel},
  data() {
    return {
      // Framework7 parameters here
      f7params: {
        id: 'io.framework7.testapp', // App bundle ID
        name: 'Framework7', // App name
        theme: 'auto', // Automatic theme detection
        // App routes
        routes: routes,
      },
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app.vue